import * as React from "react";
import "../../../../assets/scss/components/toc/generic/tocNote/tocNoteMob.scss";

export interface ITocNoteMobProps {}

const TocNoteMob: React.FC<ITocNoteMobProps> = props => {
	const [showPopup, setShowPopup] = React.useState(false);

	return (
		<div className="toc_note_mob">
			<button className="note_btn" onClick={() => setShowPopup(true)}>
				Note
			</button>

			{showPopup && (
				<>
					<div className="popup_overlay" onClick={() => setShowPopup(false)} />
					<div className="popup">
						<div className="header">
							<span className="note">Note</span>
							<span className="edel-icon-close" onClick={() => setShowPopup(false)}></span>
						</div>
						{props.children}
					</div>
				</>
			)}
		</div>
	);
};

export default TocNoteMob;
